export { Head as default } from './build/head/ExpoHead';
